import React, { useEffect, useState } from "react";
import checkAuthorization from "../config/checkAuth";
import { useNavigate } from "react-router-dom";
import * as api from "../api/api";
import Loading from "../Components/Loading";
import { Modal, Button, Form } from "react-bootstrap";
import { Snackbar, Alert } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useLanguage } from "../Components/Localization/LanguageContext";
import strings from "../Components/Localization/strings";

function AdminMasterIdles() {
  const { language } = useLanguage();
  const pageTitle = "AdminMasterIdles";

  const [isLoading, setIsLoading] = useState(true);
  const [allMasterIdles, setAllMasterIdles] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [selectedForEdit, setSelectedForEdit] = useState({});
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedForDelete, setSelectedForDelete] = useState();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [snackbarData, setSnackbarData] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const navigate = useNavigate();

  const getAllMasterIdles = () => {
    api
      .getAllMasterIdles()
      .then((response) => {
        let masterIdles = response.data.object;

        // queue up userIds in masterIdles "createdByUserId" and "modifiedByUserId"
        // so we can get the user names
        let map = new Map();
        masterIdles.forEach((masterIdle) => {
          map.set(masterIdle.createdByUserId, true);
          map.set(masterIdle.modifiedByUserId, true);
        });

        let userIds = [...map.keys()];

        let promises = userIds.map((userId) => {
          return api.getUserById(userId).then((userResponse) => {
            map.set(userId, userResponse.data.object.name);
            return userResponse.data.object.name;
          });
        });

        Promise.all(promises)
          .then(() => {
            masterIdles.forEach((masterIdle) => {
              masterIdle.createdByUserId = map.get(masterIdle.createdByUserId);
              masterIdle.modifiedByUserId = map.get(
                masterIdle.modifiedByUserId
              );
            });
            masterIdles.sort(
              (a, b) => new Date(a.created) - new Date(b.created)
            );
            setAllMasterIdles(masterIdles);
            setIsLoading(false);
          })
          .catch((error) => {
            console.error("Error fetching user data: ", error);
            setIsLoading(false);
          });
      })
      .catch((error) => {
        console.error("Error fetching master idles: ", error);
        setIsLoading(false);
      });
  };

  const addNewMasterIdle = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      const newMasterIdle = {
        name: event.target.name.value,
      };
      api.addNewMasterIdle(newMasterIdle).then((response) => {
        setShowAddModal(false);

        if (response.data.statusCode == 200) {
          setSnackbarData({
            ...snackbarData,
            message: strings[pageTitle][language].successAddSnackbar,
            show: true,
            severity: "success",
          });
          getAllMasterIdles();
        }
        // setAllMasterIdles([...allMasterIdles, response.data.object]);
      });
    }
  };

  const editMasterIdle = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      selectedForEdit.name = event.target.name.value;
      api.modifyMasterIdle(selectedForEdit).then((response) => {
        if (response.data.statusCode == 200) {
          setSnackbarData({
            ...snackbarData,
            message: strings[pageTitle][language].modifiedSuccess,
            show: true,
            severity: "success",
          });
          // replace the item in the list
          setAllMasterIdles(
            allMasterIdles.map((item) =>
              item.masterIdleId === selectedForEdit.masterIdleId
                ? { ...item, name: selectedForEdit.name }
                : item
            )
          );
        }
        setShowEditModal(false);
      });
    }
  };

  useEffect(() => {
    checkAuthorization("MASTER_IDLE").then((result) => {
      if (result) {
        getAllMasterIdles();
        //setIsLoading(false);
      } else {
        navigate("/unauthorized");
      }
    });
  }, []);

  return isLoading ? (
    <Loading></Loading>
  ) : (
    <div className="main-content">
      <p className="main-content__title">
        {strings[pageTitle][language].pageTitle}
      </p>
      <hr className="main-content-title__hr" />

      <button
        className="button-normal"
        style={{ alignSelf: "flex-end", margin: "1em" }}
        onClick={() => {
          setShowAddModal(true);
        }}
      >
        {strings[pageTitle][language].add}
      </button>

      <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
        <Form onSubmit={addNewMasterIdle}>
          <Modal.Header closeButton>
            <Modal.Title>
              {strings[pageTitle][language].addModalTitle}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>{strings[pageTitle][language].name}</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter name"
                name="name"
                required
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="light"
              onClick={() => {
                setShowAddModal(false);
                //setAddTenantIdleData({});
                //setValidatedAddTenantIdle(false);
              }}
            >
              {strings[pageTitle][language].cancel}
            </Button>
            <Button variant="primary" type="submit">
              {strings[pageTitle][language].add}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
        <Form onSubmit={editMasterIdle}>
          <Modal.Header closeButton>
            <Modal.Title>
              {strings[pageTitle][language].editModalTitle}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>{strings[pageTitle][language].name}</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter name"
                name="name"
                required
                defaultValue={selectedForEdit.name}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="light"
              onClick={() => {
                setShowEditModal(false);
                setSelectedForEdit({});
              }}
            >
              {strings[pageTitle][language].cancel}
            </Button>
            <Button variant="primary" type="submit">
              {strings[pageTitle][language].edit}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {strings[pageTitle][language].confirmDeleteModalTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5>{strings[pageTitle][language].confirmDeleteModalBody}</h5>
          <ul>
            {selectedForDelete?.tenantIdles.map((tenantIdle) => (
              <li key={tenantIdle} style={{ fontSize: "20px", color: "red" }}>
                {tenantIdle}
              </li>
            ))}
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => {
              setShowDeleteModal(false);
              setSelectedForDelete();
            }}
          >
            {strings[pageTitle][language].cancel}
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              setShowDeleteModal(false);
              api
                .deleteMasterIdle(selectedForDelete.masterIdleId)
                .then((response) => {
                  if (response.data.statusCode == 200) {
                    setSnackbarData({
                      ...snackbarData,
                      message:
                        strings[pageTitle][language].deleteSnackbarMessage,
                      show: true,
                      severity: "success",
                    });
                    getAllMasterIdles();
                  }
                });
            }}
          >
            {strings[pageTitle][language].delete}
          </Button>
        </Modal.Footer>
      </Modal>

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={snackbarData.show}
        autoHideDuration={3000}
        onClose={() => setSnackbarData({ ...snackbarData, show: false })}
      >
        <Alert severity={snackbarData.severity} sx={{ width: "100%" }}>
          {snackbarData.message}
        </Alert>
      </Snackbar>

      <table>
        <thead>
          <tr>
            <th>{strings[pageTitle][language].tableHeaders[0]}</th>
            <th>{strings[pageTitle][language].tableHeaders[1]}</th>
            <th>{strings[pageTitle][language].tableHeaders[2]}</th>
            <th>{strings[pageTitle][language].tableHeaders[3]}</th>
            <th>{strings[pageTitle][language].tableHeaders[4]}</th>
            <th>{strings[pageTitle][language].tableHeaders[5]}</th>
            <th>{strings[pageTitle][language].tableHeaders[6]}</th>
          </tr>
          {allMasterIdles.map((masterIdle) => (
            <tr key={masterIdle.masterIdleId}>
              <td>{masterIdle.name}</td>
              <td>{masterIdle.created}</td>
              <td>{masterIdle.modified}</td>
              <td>{masterIdle.createdByUserId}</td>
              <td>{masterIdle.modifiedByUserId}</td>
              <td>
                <button
                  style={{
                    border: "none",
                    outline: "none",
                    backgroundColor: "rgba(255, 0, 0, 0)",
                    color: "#00a0e5",
                  }}
                  onClick={() => {
                    setSelectedForEdit(masterIdle);
                    setShowEditModal(true);
                  }}
                >
                  <EditIcon></EditIcon>
                </button>{" "}
              </td>
              <td>
                <button
                  style={{
                    border: "none",
                    outline: "none",
                    backgroundColor: "rgba(255, 0, 0, 0)",
                    color: "#00a0e5",
                  }}
                  onClick={() => {
                    let tenantIdles = masterIdle.tenantIdles;
                    let names = [];

                    // Create an array of promises from the API calls
                    let promises = tenantIdles.map((tenantIdle) => {
                      return api
                        .getTenantById(tenantIdle.tenantId)
                        .then((response) => {
                          names.push(response.data.object.name);
                        });
                    });

                    // Use Promise.all to wait for all promises to resolve
                    Promise.all(promises).then(() => {
                      masterIdle.tenantIdles = names;
                      setSelectedForDelete(masterIdle);
                      setShowDeleteModal(true);
                    });
                  }}
                >
                  <DeleteIcon></DeleteIcon>
                </button>{" "}
              </td>
            </tr>
          ))}
        </thead>
      </table>
    </div>
  );
}

export default AdminMasterIdles;
